export default function initHeaderSlider(): void {
  Alpine.data('headerSlider', () => ({
    init() {
      const slider = this.$root;
      const images = slider.querySelectorAll('.header-images');
      let currentIndex = 0;

      // Function to show the next image
      const showNextImage = () => {
        images[currentIndex].classList.remove('opacity-100');
        images[currentIndex].classList.add('opacity-0');
        currentIndex = (currentIndex + 1) % images.length;
        images[currentIndex].classList.remove('opacity-0');
        images[currentIndex].classList.add('opacity-100');
      };

      // Start the slider
      setInterval(showNextImage, 4000); // Change image every 4 seconds
    },
  }));
}
